exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "ul.math-showcase{list-style:none}.lissajous{display:inline-block;width:200px;height:200px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/code/MasonDotNet.scss
// module id = 22
// module chunks = 0